import {connect} from 'react-redux';
import RegisterPage from './RegisterPage';
import {preRegister, register} from "modules/Auth/actions";

export default connect(
  null,
  {preRegister, register}
)(RegisterPage);
